// Configurations/graphql.js
export default function getGraphQLConfig() {
  switch (window.location.hostname) {

    case "www.uat.bms.rcshealth.io":
    case "uat.bms.rcshealth.io":
    // case "localhost":
      // return {
      //   endpoint: "https://txbecf2fi5awlcwdyj3vnez43a.appsync-api.us-east-1.amazonaws.com/graphql",
      //   region: "us-east-1",
      //   defaultAuthMode: "userPool",
      // };
        return {
        endpoint: "https://7q5gs24fbvfmdnoq7hkx3tvire.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };

    case "www.dev.bms.rcshealth.io":
    case "dev.bms.rcshealth.io":
    case "localhost":
      // return {
      //   endpoint: "https://vesvimuy2vgmdowekiqqt64dgy.appsync-api.us-east-1.amazonaws.com/graphql",
      //   region: "us-east-1",
      //   defaultAuthMode: "userPool",
      // };
       return {
        endpoint: "https://xood2tckrncmpl5bh66ziw6k3u.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };
      case "www.bms.rcshealth.io":
      case "bms.rcshealth.io":
      // case "localhost":
      return {
        endpoint: "https://b7znic56ufdn5f5jaqddzbjzie.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };

    default:
      return {
        endpoint: "https://bpfl3y5qcrgltamunmoloyz35e.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };
  }
}
